import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgSocialIconsLinkedIn = function SvgSocialIconsLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "evenodd",
    d: "M.428 12c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12s-5.372 12-12 12c-6.627 0-12-5.373-12-12m6.009 6h2.571V7.714H6.437zM7.732 6.857a1.286 1.286 0 1 1-.019-2.571 1.286 1.286 0 0 1 .019 2.571M16.437 18h2.857v-6.28c0-3.438-1.905-4.006-2.857-4.006a4.76 4.76 0 0 0-2.857.98v-.98h-2.858V18h2.858v-6.358c.226-.794.959-1.32 1.761-1.263.886 0 1.096.519 1.096 1.263z",
    clipRule: "evenodd"
  })));
};

export { SvgSocialIconsLinkedIn as ReactComponent };
//# sourceMappingURL=social-icons-linkedIn.svg.esm.js.map
